export {signUpAction as '6096e6250984eaf932deed7462b24ec27ccf0d1ba7'} from 'ACTIONS_MODULE0'
